console.log ( '%c /init/init-licence.component.ts', 'color:white;background-color:gray;' );

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatStepper, MatSnackBar, MatDialog } from '@angular/material';
import { Validators, FormControl } from '@angular/forms';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { flatMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BaseComponent } from '../commons/BaseComponent';
import { AppService } from '../commons/app.service';
import { TranslateService } from '@ngx-translate/core';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';

@Component({
  selector: 'admin-init-licence',
  templateUrl: './init-licence.component.html'
})
export class InitLicenceComponent extends BaseComponent implements OnInit {

  status:number
  message:string

  isLicenceValid:boolean = false

  checkingOther:boolean = false
  networkInterfaces:any
  selectedInterface:any

  passControl = new FormControl('', [Validators.required, Validators.maxLength(3)]);
  licenceControl = new FormControl('', [Validators.required]);
  addressControl = new FormControl('', [Validators.required]);
  netmaskControl = new FormControl('', [Validators.required]);
  gatewayControl = new FormControl('', [Validators.required]);

  constructor(public service:AppService, private route: ActivatedRoute, public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, applicationEvents:XsApplicationEventsService) {
    super(router, snackBar, dialog);
    console.log ( '%c /init/init-licence.component.ts CONSTRUCTOR', 'color:white;background-color:black;' );
  }

  ngOnInit() {

    console.log ( '%c /init/init-licence.component.ts : onInit()', 'color:white;background-color:black;' );

    this.route.queryParams.subscribe(params => {
      //console.log("ENETR initComponent params: ",params)
      this.status = params["status"]
      this.message = params["msg"]
    })

    this.checkLicence()

  }

  onStepChanged(event:StepperSelectionEvent) {
    // When optional network check then query network details from the server
    if (event.selectedIndex == 2 && !this.networkInterfaces) {
      this.checkNetwork()
    }
  }

  checkLicence() {

    console.log ( '%c /init/init-licence.component.ts : checkLicence()', 'color:white;background-color:black;' );

    this.loading = true
    this.service.V.api("/access/login/website", "get")
        .subscribe(
          res => {
            this.isLicenceValid = true
            this.loading = false
          }, err => {
            // This error status means the user has already logged in, therefore licence must be valid
            if (err.status == 4032) {
              this.isLicenceValid = true
              this.loading = false
            } else {
              this.isLicenceValid = false
              this.loading = false
            }
          }
        )
  }

  checkNetwork() {

    console.log ( '%c /init/init-licence.component.ts : checkNetwork()', 'color:white;background-color:black;' );

    this.selectedInterface = null // reset
    this.checkingOther = true

    let loginObs:Observable<any>
    if (this.service.V.localSession()) {
      // If we have a valid session we assume is an admin so use it
      loginObs = of(true)
    } else if (this.passControl.value) {
      // If no session but still have the password use it to login
      loginObs = this.service.V.loginWithUsernameObservable("admin",this.passControl.value)
    } else {
      // Otherwise ask for password and use it.
      loginObs = this.openDialog("INIT.ADMIN_PW",null,null,null,true).pipe(
        flatMap(pass => this.service.V.loginWithUsernameObservable("admin",pass))
      )
    }

    loginObs.pipe(
      flatMap(res => this.service.V.api("/admin/network", "get") )
    ).subscribe(
        res => {
          this.networkInterfaces = res
          // Try to selected the default interface to configure
          this.selectedInterface = res.find( ele => ( ele.name.toLowerCase().startsWith("e") && ele.ip4 ) )            
          this.checkingOther = false
        }, err => {

          this.checkingOther = false
        }
      )
  }

  setNetwork(netIf:any) {
    this.addressControl.setValue(netIf.ip4)
    this.netmaskControl.setValue("")
    this.gatewayControl.setValue("")
  }

  validateLicence(stepper: MatStepper, licence:string) {

    console.log ( '%c /init/init-licence.component.ts : validateLicence()', 'color:white;background-color:black;' );

    // Trigger vasat licence check end-point passing the licence key
    let args = { key: licence }
    this.loading = true
    this.service.V.api("/vasat/license/update", "post", args)
        .subscribe(
          res => {
            this.loading = false
            this.isLicenceValid = true
            //stepper.next()
            this.openSnackBarSuccess('GENERIC.SUCCESS')
          }, err => {
            this.loading = false
            this.openSnackBarError(err.message)
          }
        )
  }

  networkSetup(netIf:any) {

    console.log ( '%c /init/init-licence.component.ts : networkSetup()', 'color:white;background-color:black;' );

    let loginObs:Observable<any>

    let args = {
      name:netIf.name,
      address:this.addressControl.value,
      netmask:this.netmaskControl.value
    }

    if (this.gatewayControl.value) {
      args["gateway"] = this.gatewayControl.value
    }

    if (this.service.V.localSession()) {
      // If we have a valid session we asume is an admin so use it
      loginObs = of(true)
    } else if (this.passControl.value) {
      // If no session but still have the password use it to login
      loginObs = this.service.V.loginWithUsernameObservable("admin",this.passControl.value)
    } else {
      // Otherwise ask for password and use it.
      loginObs = this.openDialog("INIT.ADMIN_PW",null,null,null,true).pipe(
        flatMap(pass => this.service.V.loginWithUsernameObservable("admin",pass))
      )
    }
    loginObs.pipe(
      flatMap(res => this.service.V.api("/admin/network", "post", args))
    )
    .subscribe(
      res => {
        this.checkingOther = false
        this.openSnackBarSuccess('GENERIC.SUCCESS')
        // Reset to check changes applied
        //this.checkNetwork()
      }, err => {
        this.checkingOther = false
        this.openSnackBarError(err.message)
      }
    )
  
  }
}
